import { render, staticRenderFns } from "./CertificatesPreview.vue?vue&type=template&id=6030b576&scoped=true"
import script from "./CertificatesPreview.vue?vue&type=script&lang=js"
export * from "./CertificatesPreview.vue?vue&type=script&lang=js"
import style0 from "./CertificatesPreview.vue?vue&type=style&index=0&id=6030b576&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6030b576",
  null
  
)

export default component.exports